export const initialReviewDraft = (review, previous = {}) => Object.fromEntries(review.order.lines.map(line => [line.lineId,
    previous[line.lineId] || {quantity: String(line.proposedQuantity ?? line.requestedQuantity), reason: line.reason || "",
        backorderedQuantity: String(line.backorderedQuantity || 0), backorderExpectedAt: line.backorderExpectedAt?.slice(0, 16) || ""}]));

export const reviewProposal = (review, draft, delivery) => ({
    expectedVersions: review.order.versions,
    deliveryCommitment: delivery.length === 16 ? `${delivery}:00` : delivery,
    lines: review.order.lines.map(line => ({lineId: line.lineId, quantity: Number(draft[line.lineId]?.quantity),
        reason: draft[line.lineId]?.reason.trim() || null,
        ...(Number(draft[line.lineId]?.backorderedQuantity) > 0 ? {
            backorderedQuantity: Number(draft[line.lineId].backorderedQuantity),
            backorderExpectedAt: draft[line.lineId].backorderExpectedAt?.length === 16
                ? `${draft[line.lineId].backorderExpectedAt}:00` : draft[line.lineId].backorderExpectedAt,
        } : {})})),
});

export function reviewValidation(review, draft, delivery) {
    const errors = {};
    const budgets = new Map();
    const products = new Map(review.products.map(product => [product.lineId, product]));
    for (const line of review.order.lines) {
        const value = draft[line.lineId] || {};
        const quantity = Number(value.quantity);
        const backordered = Number(value.backorderedQuantity || 0);
        if (!/^\d+$/.test(value.backorderedQuantity || "0") || !Number.isSafeInteger(backordered) || backordered > quantity) {
            errors[line.lineId] = "SplitQuantityInvalid";
        } else if (backordered > 0 && (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(value.backorderExpectedAt || "")
                || value.backorderExpectedAt < delivery)) {
            errors[line.lineId] = "SplitDateInvalid";
        }
        if (!/^\d+$/.test(value.quantity ?? "") || !Number.isSafeInteger(quantity) || quantity > line.requestedQuantity) {
            errors[line.lineId] = "ReviewQuantityInvalid";
        } else if ((quantity < line.requestedQuantity || backordered > 0) && !value.reason?.trim() || (value.reason?.length || 0) > 255) {
            errors[line.lineId] = "ReviewReasonRequired";
        }
        const product = products.get(line.lineId);
        if (product && product.availableStockQuantity != null && Number.isSafeInteger(quantity)) {
            const budget = budgets.get(line.productTenantId) || {extra: 0, available: product.availableStockQuantity, ids: []};
            budget.extra += quantity - backordered - product.reservedQuantity;
            budget.available = product.listingActive === false || product.listingInStock === false ? 0 : budget.available;
            budget.ids.push(line.lineId); budgets.set(line.productTenantId, budget);
        }
    }
    for (const budget of budgets.values()) {
        if (budget.extra > budget.available) {
            budget.ids.forEach(id => {if (!errors[id]) {errors[id] = "ReviewStockChanged";}});
        }
    }
    // The server publishes its local date and zone; preserve datetime-local input without a browser UTC conversion.
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(delivery) || delivery.slice(0, 10) < review.serverDate) {
        errors.delivery = "ReviewDeliveryInvalid";
    }
    return errors;
}

export function reviewCounts(review, draft) {
    const quantities = review.order.lines.map(line => Number(draft[line.lineId]?.quantity));
    const requestedUnits = review.order.lines.reduce((sum, line) => sum + line.requestedQuantity, 0);
    const valid = quantities.every((quantity, index) => Number.isSafeInteger(quantity) && quantity >= 0
        && quantity <= review.order.lines[index].requestedQuantity && /^\d+$/.test(draft[review.order.lines[index].lineId]?.quantity ?? ""));
    const proposedUnits = valid ? quantities.reduce((sum, quantity) => sum + quantity, 0) : null;
    const backorderedUnits = review.order.lines.reduce((sum, line) => sum + Number(draft[line.lineId]?.backorderedQuantity || 0), 0);
    return {requestedUnits, proposedUnits, backorderedUnits, readyUnits: proposedUnits == null ? null : proposedUnits - backorderedUnits, requestedLines: quantities.length,
        proposedLines: valid ? quantities.filter(quantity => quantity > 0).length : null,
        outcome: proposedUnits === 0 ? "REJECTED" : proposedUnits === requestedUnits ? "FULL" : "PARTIAL"};
}
